import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VideoCollStore } from './types';

const initialState: VideoCollStore = {
  isActive: false,
};

const videoCallReducer = createSlice({
  name: 'videoCall',
  initialState,
  reducers: {
    setVideoCallIsActive: (state, action: PayloadAction<boolean>) => {
      state.isActive = action.payload;
    },
  },
});

export const { setVideoCallIsActive } = videoCallReducer.actions;

export default videoCallReducer.reducer;
